import React, {useState,useEffect} from "react";
import APIUrls from "../../services/APIUrls";
import Constants from "../../Constants";
import { Link } from "react-router-dom";
import { getAxiosResponse,downloadFile } from "../../services/authApiRoutes/APImethods";
export default function FileDownloadMenuItems(prop) {
    const entry = prop.entry
    const projectId = prop.projectId
    const translatedAsset = prop.translatedAsset
  const sourcePreviewBundle = prop.sourcePreviewBundle
  const targetPreviewBundle = prop.targetPreviewBundle
  const [offlinePreviewBundle, setOfflinePreviewBundle] = useState([]);
  const [downloadMenuItems, setDownloadMenuItems] = useState([]);
  
  var targetFileId = null;
  var sourceFileId = null;

  const messages = {
    source_file: "Source file",
    translated_file: "Translated file",
    src_translatable_file: "Source file",
    trans_translatable_file: "Translated file",
    bilingual_review_file: "Bilingual review file",
    src_intermediate_file: "Source Intermediate file",
    trans_intermediate_file: "Translated Intermediate file",
    source_preview_bundle: "Source Offline Preview",
    target_preview_bundle: "Target Offline Preview",
    source_file_video: "Source Video",
    translated_file_video: "Translated Video",
    src_translatable_file_video: "Source Subtitle",
    trans_translatable_file_video: "Translated Subtitle",
    src_intermediate_file_video: "Source Subtitle",
    trans_intermediate_file_video: "Translated Subtitle",
  };
  const downloadAsset = (event, item, fileName) => {
    event.preventDefault();
    var newFileName = fileName ? fileName : item?.fileName;
    if (item.text.endsWith(" (.xlf)") && !item.fileName.endsWith(".xlf")) {
      newFileName += ".xlf";
    } else if (item.text.endsWith(" (.docx)") || item.text.endsWith(" (.zip)")) {
      newFileName = item.fileName;
    } else if (item.text === "Bilingual review file") {
      newFileName = `Review-${newFileName}.docx`;
    }
    downloadFile(APIUrls.DOWNLOAD_ASSET_FILES(item.link), newFileName);
  };
  async function getOfflinePreview(sourceId, targetId, translatedAsset, items) {
      let sourcePreviewBundleZip = sourcePreviewBundle;
      let targetPreviewBundleZip = targetPreviewBundle;
      var sourceFile = sourcePreviewBundleZip.find((element) => {
        return element.comment == String(sourceId);
      });
      var targetFile = targetPreviewBundleZip.find((element) => {
        return element.comment == String(targetId);
      });
      if (sourceFile && sourceFile.id) {
        items.push({
          link: APIUrls.DOWNLOAD_FILE(sourceFile.id, "PROJECT", projectId),
          text: Constants.SOURCE_PREVIEW_BUNDLE,
          id: sourceId,
          fileName: sourceFile.filename,
        });
      }
      if (targetFile && targetFile.id) {
        items.push({
          link: APIUrls.DOWNLOAD_FILE(targetFile.id, "PROJECT", projectId),
          text: Constants.TARGET_PREVIEW_BUNDLE,
          id: targetId,
          fileName: targetFile.filename,
        });
      }
      setOfflinePreviewBundle(items);
  }
  const isVideoAssetType = (logicalProjectAsset) => {
    // FIXME: This is no robust check. It has been placed as hack for enabling feature
    var isVideoAsset = false,
      assetDetails = logicalProjectAsset.assets,
      asset = assetDetails[0];

    // this check for external asset -- this is really sloppy
    if (
      assetDetails &&
      asset &&
      asset.parentAssetType &&
      asset.parentAssetType === "video"
    ) {
      isVideoAsset = true;
      this.videoUrl = asset.parentAssetUrl;
    }
    // this is for project created with local source upload
    else if (logicalProjectAsset.fileType && logicalProjectAsset.fileType==="MP4"
    ) {
      isVideoAsset = true;
    }
    return isVideoAsset;
  };
  const getExtension = (name) => {
    if (name.documentFile) {
      name = name.documentFile;
    }

    var fileExtenstion;

    if (name.filename) {
      name = name.filename;
    }

    if (name.endsWith(".pdf.html")) {
      fileExtenstion = "pdf";
    } else {
      fileExtenstion = name.substr(name.lastIndexOf(".") + 1);
    }
    return fileExtenstion;
  };
  const getFileDownloadMenuItems = (translatedAsset) => {
    var assets = translatedAsset.files;
    var items;

    var isTranslatableFileExtractedXLIFF = false;
    var isFinalFileXLIFF = false;
    Object.keys(assets).map((item) => {
      if (assets[item].type === "TRANSLATABLE") {
        isTranslatableFileExtractedXLIFF =
          assets[item].documentFile.filename.endsWith(".xlf");
      } else if (assets[item].type === "FINAL") {
        isFinalFileXLIFF = assets[item].documentFile.filename.endsWith(".xlf");
      }
    });
    if (translatedAsset.source !== "") {
      items = getFileDownloadMenuItems(translatedAsset.source);
    } else {
      items = [];
    }
    var isVideoAsset = isVideoAssetType(translatedAsset);
    var msgKeySuffix = isVideoAsset ? "_video" : "";

    Object.keys(assets).map((document, key) => {
      var msgKeyPrefix = "";
      if (assets[document].type === "TRANSLATABLE") {
        if (translatedAsset.source) {
          targetFileId = assets[document].documentFile.fileId;
        } else {
          sourceFileId = assets[document].documentFile.fileId;
        }
        msgKeyPrefix = translatedAsset.source
          ? "trans_translatable"
          : "src_translatable";
      } else if (assets[document].type === "FINAL") {
        if (targetFileId === null && translatedAsset.source) {
          targetFileId = assets[document].documentFile.fileId;
        } else if (sourceFileId === null) {
          sourceFileId = assets[document].documentFile.fileId;
        }
        msgKeyPrefix = translatedAsset.source ? "translated" : "source";
      } else if (assets[document].type === "INTERMEDIATE") {
        msgKeyPrefix = translatedAsset.source
          ? "trans_intermediate"
          : "src_intermediate";
      }

      var downloadFileText =
        messages[msgKeyPrefix + "_file" + msgKeySuffix] +
        " (." +
        getExtension(assets[document]) +
        ")";
      if (isTranslatableFileExtractedXLIFF && isFinalFileXLIFF) {
        var prefixForDownloadFileText = "";
        switch (msgKeyPrefix) {
          case "source":
          case "translated":
            prefixForDownloadFileText = " (Integration)";
            break;
          case "trans_translatable":
          case "src_translatable":
            prefixForDownloadFileText = " (LSP)";
            break;
          default:
            return "";
        }
        downloadFileText += prefixForDownloadFileText;
      }
      items.push({
        link:APIUrls.DOWNLOAD_FILE(assets[document].documentFile.fileId, "PROJECT", projectId),
        text: downloadFileText,
        id: translatedAsset.id,
        fileName: translatedAsset.name,
      });
    });
    if (targetFileId && sourceFileId) {
      getOfflinePreview(sourceFileId, targetFileId, translatedAsset, items);
      targetFileId = null;
      sourceFileId = null;
    }

    var statusArray = ["SYNCING", "PROCESSING", "HELD"];
    if (
      translatedAsset.lineByLineEnabled &&
      translatedAsset.source.id !== undefined &&
      !(statusArray.indexOf(translatedAsset.status) > 1)
    ) {
      items.push({
        link: APIUrls.DOWNLOAD_BILINGUALS(projectId,translatedAsset.id),
        text: messages["bilingual_review_file"],
        id: translatedAsset.id,
        fileName: translatedAsset.name,
      });
    }
    return items;
  };
  
  useEffect(()=>{
    setDownloadMenuItems([])
    setOfflinePreviewBundle([])
    translatedAsset.forEach((asset)=>{
        var menuItems = getFileDownloadMenuItems(asset);
            menuItems.map((item) => {
              setDownloadMenuItems((current) => [...current, item]);
            });
    })
  },[translatedAsset])

  

  useEffect(() => {
    offlinePreviewBundle.map((item) => {
      var index = downloadMenuItems.findIndex(
        (x) => x.text == item.text && x.id === item.id
      );
      if (index === -1) {
        setDownloadMenuItems((current) => [...current, item]);
      }
    });
  }, [offlinePreviewBundle]);
  return (
 
  downloadMenuItems.map((menu, index) => {
    if (menu.id === entry.id || menu.id === entry.source.id) {
      return (
        <li key={index}>
           {menu.text.endsWith("(.mp4)") ? (
          <Link aria-label={menu.text + " download"} to="#"
            onClick={(e) => downloadAsset(e,menu,entry.name)}>
            {menu.text}
          </Link>
    
           ):(
       <Link aria-label={menu.text + " download"} to="#"
       onClick={(e) => downloadAsset(e,menu,entry.source.files?.INTERMEDIATE?.documentFile?.filename)}>
       {menu.text}
     </Link>
      )}
        </li>
      );
     }
     if(menu.id && (menu.id == entry.files?.TRANSLATABLE?.documentFile?.fileId || menu.id == entry.files?.FINAL?.documentFile?.fileId || menu.id == entry.source.files?.TRANSLATABLE?.documentFile?.fileId || menu.id == entry.source.files?.FINAL?.documentFile?.fileId)){
      return (
        <li key={index}>
          <Link aria-label={menu.text + " download"} to="#"
            onClick={(e) =>downloadAsset(e,menu,entry.name)}>
            {menu.text}
          </Link>
        </li>
      );
     }
   })
   
  )
}
